import React, { memo, ReactElement, useEffect, useState } from 'react'
import { useGoogleMap, Marker } from '@react-google-maps/api'
import EstablishmentIcon from '../../../../assets/svg/map-establishment.svg'

type NearbyPlacesStateTypes = {
  [key: string]: NearbyPlacesResultTypes
}

type NearbyPlacesResultTypes = {
  place_id: string
  geometry: {
    location: {}
  }
  name?: string
}[]

type NearbyPlacesPropTypes = {
  center: {
    position: {
      lat: number
      lng: number
    }
  }
  radius: number
  nearbyPlacesTypes: string[]
}

const NearbyPlaces = ({
  center,
  radius,
  nearbyPlacesTypes,
}: NearbyPlacesPropTypes): ReactElement => {
  const [nearbyPlaces, setNearbyPlaces] = useState<NearbyPlacesStateTypes>({})
  const map = useGoogleMap()

  useEffect((): void => {
    setNearbyPlaces((currentNearbyPlaces) => {
      const tempNearbyPlaces: NearbyPlacesStateTypes = {}

      nearbyPlacesTypes.forEach((nearbyPlacesType): void => {
        const currentValues = currentNearbyPlaces[nearbyPlacesType]

        if (currentValues) {
          tempNearbyPlaces[nearbyPlacesType] = currentValues
        }
      })

      return tempNearbyPlaces
    })

    const { places } = window.google.maps

    const service = new places.PlacesService(map)

    const getCallBack = (currentType: string) => (
      results: NearbyPlacesResultTypes,
      status: string,
    ): void => {
      if (status === places.PlacesServiceStatus.OK) {
        setNearbyPlaces((currentNearbyPlaces) => {
          const tempNearbyPlaces = { ...currentNearbyPlaces }

          tempNearbyPlaces[currentType] = results

          return tempNearbyPlaces
        })
      }
    }
    if (nearbyPlacesTypes.length) {
      nearbyPlacesTypes.forEach((nearbyPlacesType): void => {
        service.nearbySearch(
          {
            location: center,
            radius,
            type: nearbyPlacesType,
          },
          getCallBack(nearbyPlacesType),
        )
      })
    }
  }, [map, center, radius, nearbyPlacesTypes])

  return (
    <>
      {Object.entries(nearbyPlaces).map(([, nearbyPlaceSet]) => (
        <>
          {nearbyPlaceSet.map((nearbyPlace) => (
            <Marker
              key={nearbyPlace.place_id}
              icon={EstablishmentIcon}
              position={nearbyPlace.geometry.location}
            />
          ))}
        </>
      ))}
    </>
  )
}

export default memo(NearbyPlaces)
